import * as d3 from 'd3-selection'

/*
 * Returns the total width of a tree node, including the extra
 * space caused by transform: translateX().
 */

function nodeWidth(node) {
	var nodeContent = node.find('.node-contents')[0]
	// To accurately check if a node has overflowing content, we need to compare the outerWidth
	// to the sum of its content's scrollWidth and translateX value.
	var translateX = d3.select(nodeContent).datum()._x
	return parseInt(nodeContent.scrollWidth) + parseInt(translateX)
}

export default nodeWidth
nodeWidth.__filename__ = 'components/node-width.js'
